import { isNil, isEmpty } from 'ramda';
export var makeName = function () {
    var names = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        names[_i] = arguments[_i];
    }
    return names.filter(function (name) { return !isNil(name) && !isEmpty(name); }).join('.');
};
